import { injToken } from '@shared/data/token'
import { getAuthApi, getBankApi, getRestAuthApi } from '@shared/service/chain'

export const fetchAccountDetails = async (address: string) => {
  const chainRestAuthApi = await getRestAuthApi()
  const accountDetailsResponse = await chainRestAuthApi.fetchAccount(address)
  const { BaseAccount } = await import('@injectivelabs/sdk-ts/core/accounts')

  return BaseAccount.fromRestApi(accountDetailsResponse).toAccountDetails()
}

export const fetchAccountDetailsUsingGrpc = async (address: string) => {
  const chainGrpcAuthApi = await getAuthApi()
  const accountDetailsResponse = await chainGrpcAuthApi.fetchAccount(address)

  return accountDetailsResponse
}

export const fetchAccountDetailsUsingGrpcNoThrow = async (address: string) => {
  try {
    const chainGrpcAuthApi = await getAuthApi()
    const accountDetailsResponse = await chainGrpcAuthApi.fetchAccount(address)

    return accountDetailsResponse
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return null
  }
}

export const fetchInjBalanceNoThrow = async (
  address: string
): Promise<string | undefined> => {
  try {
    const chainBankApi = await getBankApi()
    const { balances } = await chainBankApi.fetchBalances(address)

    return balances.find(({ denom }) => denom === injToken.denom)?.amount || '0'
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return undefined
  }
}
